module.exports = __webpack_public_path__ + "img/wsDash.77cecb01.png";